export enum EmbedLogoVisibility {
  ControlBar = 'CONTROL_BAR',
  Always = 'ALWAYS',
}
